module.exports = __webpack_public_path__ + "static/media/xiamen.4c15732.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mapVideos/fujian/xiamen.mp4
// module id = kq26
// module chunks = 6